import React, { useState } from 'react'
import FooterTailwind from 'TailwindcssComponents/Footer'
import TailwindLayout from 'TailwindcssComponents/TailwindLayout'
import TopBar from 'TailwindcssComponents/TopBar'
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

export default function VerifyToken() {

    const bearerToken = localStorage.getItem('token');
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const [token, setToken] = useState();
    const navigate = useNavigate();
    const params = new URLSearchParams(useLocation().search);

    const verifyToken = async () => {
        try {
            const formData = new URLSearchParams();
            formData.append('token', token);

            const response = await axios.post(`${apiUrl}auth-service/auth/verify-email`, formData, {
                headers: {
                    'Authorization': `Bearer ${bearerToken}`,
                    'Content-Type': `application/x-www-form-urlencoded`,
                },
            });
            if (response.data?.success) {
                // setTimeout(() => {
                navigate(`/userRoles/add-userRoles?token=${params.get('token')}&roleName=${params.get('name')}&orgName=${params.get('orgName')}`);
                toast.info(response.data.message || 'Email has been verified successfully');
                // }, 500);
            } else {
                throw new Error("Failed to verify email");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
        }
        // finally {
        //     setTimeout(() => {
        //         navigate('/dashboard');
        //     }, 1500);
        // }
    };

    return (
        <TailwindLayout>
            <TopBar />
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-md">
                    <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Email Verification</h2>
                    <p className="text-gray-600 mb-6 text-center">
                        Enter token here
                    </p>
                    <div className="flex justify-center space-x-4">
                        <input
                            type="text"
                            value={token}
                            onChange={(e) => setToken(e.target.value)}
                            className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter token"
                        />
                        <button
                            onClick={verifyToken}
                            className="px-6 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
            <FooterTailwind />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </TailwindLayout>
    )
}
